
import * as constants from "../assets/constants";
import {baseApi} from "./BaseApi";



class SalePointMonitoringDocsApi extends baseApi {


    getOne = async (id) => {

        return await this.get(`?app=SalePointMonitoring&act=getOne&doc_id=${id}`)

    }
    setStatus = async (data) => {

        return await this.post(`?app=SalePointMonitoring&act=setStatus`, data)

    }
    setKlient = async (data) => {

        return await this.post(`?app=SalePointMonitoring&act=setKlient`, data)

    }
    setUseMall = async (data) => {

        return await this.post(`?app=SalePointMonitoring&act=setUseMall`, data)

    }
    setImages = async (data) => {

        return await this.post(`?app=SalePointMonitoring&act=setImages`, data)

    }
    setVideos = async (data) => {

        return await this.post(`?app=SalePointMonitoring&act=setVideos`, data)

    }
    setMall = async (data) => {

        return await this.post(`?app=SalePointMonitoring&act=setMall`, data)

    }

    setSalePoint = async (data) => {

        return await this.post(`?app=SalePointMonitoring&act=setSalePoint`, data)

    }

     getList = async (data) => {

        return await this.post('?app=SalePointMonitoring&act=getList', data)

    }


     save = async (data) => {
        return await this.post('?app=SalePointMonitoring&act=save', {body:JSON.stringify(data)})

    }

    delete = async (id) => {
        return await this.post('?app=SalePointMonitoring&act=setDeleted', {id})

    }

}

export default new SalePointMonitoringDocsApi(constants.DEBUG?constants.base_url_stage:constants.base_url_prod);